import { FEATURE } from '~/common/enums/feature.enum';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';

const useContestInvite = () => {
  const isInviteCTAShown = useIsFeatureEnabled(FEATURE.SHOW_CONTEST_INVITE_CTA);

  return { isInviteCTAShown };
};
export default useContestInvite;
